import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { PatternFormat } from 'react-number-format';
import { InsetWrapper } from '../../CheckoutProcess/components/InsetWrapper';
import { PaymentContext } from '../contexts/PaymentContext';
import { getCountryISONumber } from '../utils/getCountryISONumber';
import CreditCards from './CreditCards';

export class CardinalCommerceCreditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderID: '',
      number: '',
      expMonth: '',
      expYear: '',
      ccv: '',
      zip: '',
      address: {
        name: this.props.name,
        address: this.props.defaultAddress.address,
        address2: this.props.defaultAddress.address2,
        city: this.props.defaultAddress.city,
        state: this.props.defaultAddress.state,
        country: this.props.defaultAddress.country,
        zip: this.props.defaultAddress.zip,
        phone: this.props.phone,
      },
      loading: false,
      cardinalCommerceData: '',
    };
  }

  onSuccess = () => {
    this.setState({ loading: false });
  };

  onError = () => {
    this.setState({ loading: false });
  };

  onGetCardinalDataSuccess = (jwt, orderID) => {
    Cardinal.setup('init', {
      jwt,
    });

    this.setState({
      orderID,
      loading: false,
    });
  };

  onNumberChange = (e) => {
    this.setState({ number: e.target.value });
  };

  onMonthChange = (e) => {
    this.setState({ expMonth: e.target.value });
  };

  onYearChange = (e) => {
    this.setState({ expYear: e.target.value });
  };

  onCCVChange = (e) => {
    this.setState({ ccv: e.target.value });
  };

  onZipChange = (e) => {
    let address = { ...this.state.address };
    address.zip = e.target.value;
    this.setState({ zip: e.target.value, address });
  };

  onAddressChange = (address) => {
    this.setState({ address });
  };

  submitPayment = (e, jwt = '') => {
    if (e) {
      e.preventDefault();
    }
    if (this.state.loading === true) {
      return;
    } else {
      this.setState({ loading: true });
    }

    if (this.props.isFullyPaid) {
      return;
    }

    this.props.onPaymentInitiated();

    let cardNumber = this.state.number.replace(/\s+/g, '');
    let payload = {
      name: this.state.address.name,
      number: cardNumber,
      expiration_month: this.state.expMonth,
      expiration_year: this.state.expYear,
      security_code: this.state.ccv,
      ...this.state.address,
      amount: this.props.amount,
      email: this.props.email,
      tos_accepted: this.props.tosAccepted,
      captureMethod: this.props.captureMethod,
      emailOptOut: this.props.emailOptOut,
      leapOptIn: this.props.leapOptIn,
      cardinal_commerce_data: jwt,
    };

    if (this.props.createdNewAccount) {
      payload.sendAccountEmail = 1;
    }

    this.props.onPaymentSubmit(payload, { onSuccess: this.onSuccess, onError: this.onError });
  };

  componentDidMount() {
    let genericErrorMessage = 'Error submitting payment';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let that = this;
    let cardinalCommerceScript = document.createElement('script');
    cardinalCommerceScript.src = this.props.jsUrl;
    cardinalCommerceScript.type = 'text/javascript';
    cardinalCommerceScript.async = false;
    cardinalCommerceScript.onload = () => {
      Cardinal.configure({});

      Cardinal.on('payments.validated', function (data, jwt) {
        if (typeof data.ErrorNumber !== 'undefined' && data.ErrorNumber === 0) {
          that.submitPayment(null, jwt);
        } else {
          that.props.onPaymentFail([{ detail: genericErrorMessage }]);
        }
      });

      this.props.onGetCardinalData({ onSuccess: this.onGetCardinalDataSuccess, onError: this.onError });
    };

    document.getElementsByTagName('head')[0].appendChild(cardinalCommerceScript);
  }

  render() {
    return (
      <PaymentContext.Consumer>
        {({ TranslationContext, LocalizedAddress }) => (
          <TranslationContext.Consumer>
            {(t) => (
              <section className="checkout-form__section">
                <h4 className="checkout-form__sub-heading checkout-form__credit-card__sub-heading">
                  <div className="flex-left">{t.t('checkout__credit_card_details')}</div>
                  <div className="flex-right">
                    <CreditCards acceptedCards={this.props.acceptedCards} />
                  </div>
                </h4>
                <form id="payment-submit-form" onSubmit={this.submitPayment}>
                  <InsetWrapper>
                    <div className="input__top">
                      <label className="input__label" htmlFor="card__input-number">
                        {t.t('checkout__card_number')}
                      </label>
                    </div>
                    <PatternFormat
                      format="#### #### #### ####"
                      type="tel"
                      id="card__input-number"
                      required
                      className="input__control card__input card__input-number"
                      placeholder="Card Number"
                      pattern="[0-9 ]{14,23}"
                      autoComplete="cc-number"
                      name="number"
                      value={this.state.number}
                      onChange={this.onNumberChange}
                    />
                  </InsetWrapper>
                  <div className="row card__input-group">
                    <div className="col-sm-6">
                      <div className="card__input-date-group">
                        {/* <label htmlFor="exp" className="input__label">Expiration Date</label> */}
                        <div className="card__input-date">
                          <div className="card__input-month">
                            <InsetWrapper>
                              <label htmlFor="card__input-month" className="input__label">
                                MM
                              </label>
                              <input
                                type="tel"
                                id="card__input-month"
                                required
                                className=" input__control card__input"
                                placeholder="MM"
                                pattern="[0-9]{1,2}"
                                autoComplete="cc-exp-month"
                                name="expiration_month"
                                value={this.state.expMonth}
                                onChange={this.onMonthChange}
                                maxLength="2"
                              />
                            </InsetWrapper>
                          </div>
                          <span className="card__date-text"> / </span>
                          <div className="card__input-year">
                            <InsetWrapper>
                              <label htmlFor="card__input-year" className="input__label">
                                YYYY
                              </label>
                              <input
                                type="tel"
                                id="card__input-year"
                                required
                                className="input__control card__input card__input-date"
                                placeholder="YYYY"
                                pattern="[0-9]{2,4}"
                                autoComplete="cc-exp-year"
                                name="expiration_year"
                                value={this.state.expYear}
                                onChange={this.onYearChange}
                                maxLength="4"
                              />
                            </InsetWrapper>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="card__input-cvc">
                        <InsetWrapper>
                          <label className="input__label" htmlFor="card__input-cvc">
                            {t.t('checkout__cvc_code')}
                          </label>
                          <input
                            type="tel"
                            id="card__input-cvc"
                            required
                            className="input__control card__input card__input_cvc"
                            placeholder="CVC Code"
                            autoComplete="cc-cvc"
                            name="security_code"
                            value={this.state.ccv}
                            maxLength="4"
                            inputMode="numeric"
                            pattern="[0-9]{3,4}"
                            onChange={this.onCCVChange}
                          />
                        </InsetWrapper>
                      </div>
                    </div>
                  </div>
                  <button
                    style={{ display: 'none' }}
                    id="payment-form-invisible-button"
                    onClick={this.onPaymentButtonClick}
                    type="submit"
                  >
                    Invisible display button
                  </button>
                </form>
                <LocalizedAddress
                  {...this.state.address}
                  onAddressChange={this.onAddressChange}
                  header={t.t('checkout__billing_address')}
                />
              </section>
            )}
          </TranslationContext.Consumer>
        )}
      </PaymentContext.Consumer>
    );
  }

  //CyberSource 3DS using Cardinal Commerce
  onPaymentButtonClick = (e) => {
    e.preventDefault();
    Cardinal.start('cca', this.getOrderObject());
  };

  getOrderObject = () => {
    //prepare some fields
    let card_expiration_month = this.state.expMonth;
    if (card_expiration_month.length === 1) {
      card_expiration_month = '0' + card_expiration_month;
    }
    let splitName = this.props.name.split(' ');
    let first_name = splitName[0];
    let last_name = splitName[splitName.length - 1];

    //return Order Object
    return {
      OrderDetails: {
        Amount: this.props.amount,
        CurrencyCode: this.props.currency,
        OrderNumber: this.state.orderID,
      },
      Consumer: {
        Account: {
          AccountNumber: this.state.number.replace(/\s/g, ''),
          ExpirationMonth: card_expiration_month,
          ExpirationYear: this.state.expYear,
          CardCode: this.state.ccv,
          NameOnAccount: this.props.name,
        },
        BillingAddress: {
          FirstName: first_name,
          LastName: last_name,
          Address1: this.state.address.address,
          Address2: this.state.address.address2,
          City: this.state.address.city,
          State: this.state.address.state,
          PostalCode: this.state.address.zip,
          CountryCode: getCountryISONumber(this.state.address.country),
          Phone1: this.props.phone,
        },
        ShippingAddress: {
          FirstName: first_name,
          LastName: last_name,
          Address1: this.state.address.address,
          Address2: this.state.address.address2,
          City: this.state.address.city,
          State: this.state.address.state,
          PostalCode: this.state.address.zip,
          CountryCode: getCountryISONumber(this.state.address.country),
          Phone1: this.props.phone,
        },
        Email1: this.props.email,
      },
    };
  };
}

CardinalCommerceCreditCard.propTypes = {
  onPaymentInitiated: PropTypes.func.isRequired,
  onPaymentSuccess: PropTypes.func.isRequired,
  onPaymentFail: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string,
  phone: PropTypes.string,
  token: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  tosAccepted: PropTypes.bool.isRequired,
  acceptedCards: PropTypes.object,
  captureMethod: PropTypes.number,
  isFullyPaid: PropTypes.bool,
  createdNewAccount: PropTypes.bool,
  emailOptOut: PropTypes.bool,
  leapOptIn: PropTypes.bool,
  defaultAddress: PropTypes.object,
};

CardinalCommerceCreditCard.defaultProps = {
  phone: '',
  name: '',
  acceptedCards: {},
  captureMethod: 1, // CAPTURE_ONLINE
  defaultAddress: {},
};

export default CardinalCommerceCreditCard;
